/**
 * 
 * @param {String} value 
 * @param {String} format
*/
export default function numberFormat(value, format) {
  let hashCount = 0;
  let a = '';

  for (let i = 0, ln = format.length; i < ln; i++) {
    if (format[i] === '.') {
      format1 = format.split('.');
      console.log(format1);

      if (format1 = format.split('.').length === 3) {
        console.log('a');
      } else {
        hashCount = format1[1].length;

        switch (hashCount) {
          case 3:
            a = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            break;

          case 2:
            a = value.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
            break;

          default:
            return 'Invalid format';
        }

        return a;
      }
    }

    if (format[i] === ' ') {
      const formatArray = format.split('#').filter(str => str !== '');
      let start = 0;
      let numStr = '';

      for (let i = 0, ln = format.length; i <= ln; i++) {
        const part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

        const index = i === ln ? value.length : value.indexOf(part, start);
        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */

        if (index === -1) {
          numStr = value;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.toString() || []).replace(/\B(?=(\d{4})+(?!\d))/g, " ");
    }
  }
}
;